import React from "react";
import { ReactComponent as IconInfo } from "../../assets/images/icons/info.svg";

const changes: {date: string, summary: string}[] = [
// {
//   "date": "Apr 7, 2022",
//   "summary": (
//     <>
//       <p><b>The SCW app has been updated with the following changes:</b></p>
//       <ul>
//         <li>Fixed an issue on suppliers overview page with incorrect types showing while these types are not available.</li>
//         <li>Added loading date and delivery date approximate checkbox. Now the rate request form will have an open input field when "Approximate date" is selected. You can enter any form text in there.</li>
//         <li>Added inclusions details for each selected rate request mode in supplier response screen.</li>
//       </ul>
//     </>
//   ),
// },
];

export default changes.reverse();
